module.exports = __webpack_public_path__ + "img/kizi.3b3a51e8.png";